import { render, staticRenderFns } from "./B2bCheck.vue?vue&type=template&id=603f5bc8&scoped=true&"
import script from "./B2bCheck.vue?vue&type=script&lang=js&"
export * from "./B2bCheck.vue?vue&type=script&lang=js&"
import style0 from "./B2bCheck.vue?vue&type=style&index=0&id=603f5bc8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603f5bc8",
  null
  
)

export default component.exports